import { getExtensionDistributionType } from '../../ExtensionInstallation/utils/extensionIds.mjs'
import { FilterGroup } from '../../SessionUrlFilters/FilterGroup.mjs'
import { createDefaultFilters } from './createDefaultFilters.mjs'

export function createDefaultExtensionFilters(extensionId) {
  let filters = []
  const distributionType = getExtensionDistributionType(extensionId)
  switch (distributionType) {
    case 'studentLink':
    case 'oneClick':
      filters = createDefaultFilters()
  }

  return new FilterGroup({ filters })
}
